import React, { SFC } from 'react';
import classNames from 'classnames';
import styles from './notification.styl';

interface NotificationProps {
  type: 'error' | 'notify' | 'success' | 'default';
  transparent?: boolean;
  dismissible?: boolean;
  onRequestClose?: () => void;
}

export const Notification: SFC<NotificationProps> = ({
  type,
  transparent,
  dismissible,
  onRequestClose,
  children,
}) => {
  return (
    <div
      className={classNames(
        `mx-alert-${type}`,
        { ['mx-alert-transparent']: transparent },
        { ['mx-alert-dismissible']: dismissible },
        styles.root,
      )}
    >
      {dismissible && <span className="mx-alert-close" onClick={onRequestClose} />}
      {children}
    </div>
  );
};
